import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import AdminBrand from './AdminBrand';
import AdminMenuContent from './AdminMenuContent';
import AdminUserFooter from './AdminUserFooter';

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function AdminSideMenuMobile({ open, onClose }: Props) {
  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      slotProps={{ paper: { sx: { width: 280 } } }}
      sx={{ display: { md: 'none' } }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <AdminBrand />
        <Box sx={{ flex: 1, overflow: 'auto' }}>
          <AdminMenuContent onNavigate={onClose} />
        </Box>
        <AdminUserFooter />
      </Box>
    </Drawer>
  );
}
